interface TimeUnit {
  value: number;
  suffix: string;
}

export const formatTimeElapsed = (startDate: string): string => {
  const calculateTimeDifference = (date1: Date, date2: Date): number => {
    return Math.abs(date2.getTime() - date1.getTime());
  };

  const getTimeUnits = (milliseconds: number): TimeUnit[] => {
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    return [
      { value: days, suffix: 'd' },
      { value: hours % 24, suffix: 'h' },
      { value: minutes % 60, suffix: 'm' },
      { value: seconds % 60, suffix: 's' },
    ];
  };

  const formatUnits = (units: TimeUnit[]): string => {
    const firstNonZeroIndex = units.findIndex((unit) => unit.value > 0);
    if (firstNonZeroIndex === -1) return '0s';

    return units
      .slice(firstNonZeroIndex)
      .map(({ value, suffix }) => `${value}${suffix}`)
      .join(' ');
  };

  const start = new Date(startDate);
  const now = new Date();
  const elapsed = calculateTimeDifference(start, now);
  const timeUnits = getTimeUnits(elapsed);
  return formatUnits(timeUnits);
};

const calculateTimeDifference = (date1: Date, date2: Date): number => {
  return date1.getTime() - date2.getTime();
};

export const formatTimeRemaining = (endDate: string): string => {
  const getTimeUnits = (milliseconds: number): TimeUnit[] => {
    if (milliseconds <= 0) {
      return [{ value: 0, suffix: 's' }];
    }
    const seconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    return [
      { value: days, suffix: 'd' },
      { value: hours % 24, suffix: 'h' },
      { value: minutes % 60, suffix: 'm' },
      { value: seconds % 60, suffix: 's' },
    ];
  };

  const formatUnits = (units: TimeUnit[]): string => {
    if (units.length === 1 && units[0].value === 0 && units[0].suffix === 's') {
      return '0s';
    }

    const firstNonZeroIndex = units.findIndex((unit) => unit.value > 0);
    if (firstNonZeroIndex === -1) return '0s';

    return units
      .slice(firstNonZeroIndex)
      .map(({ value, suffix }) => `${value}${suffix}`)
      .join(' ');
  };

  const end = new Date(endDate);
  const now = new Date();
  const remaining = calculateTimeDifference(end, now);
  const timeUnits = getTimeUnits(remaining);
  return formatUnits(timeUnits);
};

export const getNow = () => {
  return new Date().toISOString();
};

export const olderThanADay = () => {
  const now = new Date();
  const oneDayAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  return oneDayAgo;
};
